<div class="external-command-container">
  <button [matBadge]="numbersCommand()"
    mat-raised-button color="primary" [matMenuTriggerFor]="commandMenu" class="command-button">
    <mat-icon>settings</mat-icon>
    {{'IotDevices.externalCommand' | translate}}
  </button>

  <mat-menu #commandMenu="matMenu" class="command-menu" [hasBackdrop]="false"
    [backdropClass]="'cdk-overlay-transparent-backdrop'">
    <div class="menu-content" (click)="$event.stopPropagation()">
      <div class="menu-header">
        <h3>{{'IotDevices.externalCommandConfigure' | translate}}</h3>
        <button mat-icon-button color="primary" (click)="addCommand()" class="add-button">
          <mat-icon>add</mat-icon>
        </button>
      </div>

      <form [formGroup]="commandForm" class="commands-form">
        <mat-accordion class="commands-accordion" formArrayName="commands">
          @for (command of commandsFormArray.controls; track command; let i = $index) {
            <mat-expansion-panel
              [formGroupName]="i">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <button mat-icon-button color="warn"
                    (click)="removeCommand(i); $event.stopPropagation()" class="delete-button">
                    <mat-icon>delete</mat-icon>
                  </button>
                  @if (getCommandFormGroup(i).value; as commandValues) {
                    <span class="command-id">
                      @if(commandValues.commandId){
                        {{'possibleCommands.' + commandValues.commandId|translate }}
                      }
                    </span>
                  }
                </mat-panel-title>
                <mat-panel-description>
                  @if (getCommandFormGroup(i).value; as commandValues) {
                    <span> @if(commandValues.elementId){
                      {{commandValues.elementId|transformValueByPredicateFunction:getElementNamePredicate:elementsSignal()
                      }}
                    }</span>
                  }
                </mat-panel-description>
              </mat-expansion-panel-header>
              <div class="command-fields">
                @if (periodDataValuesElement( ); as pValues) {
                  <app-auto-complete-form-standalone formControlName="commandId"
                    [title]="'IotDevices.externalCommandId'|translate" registerOnChangeKeyValue="valueForm"
                    [itemsGroup]="pValues" appearance="outline" [hiddenClearButton]="true">
                  </app-auto-complete-form-standalone>
                }
                @if
                  (elementsSignal()|transformValueByPredicateFunction:possibleValuesElementsPredicate:getCommandFormGroup(i).get('commandId')?.value:('suggested'|translate):('other'|translate)
                  ; as pValues) {
                  <app-auto-complete-form-standalone formControlName="elementId"
                    [title]="'IotDevices.externalInfoSensorId'|translate"
                    registerOnChangeKeyValue="valueForm" [itemsGroup]="pValues" appearance="outline"
                    [hiddenClearButton]="true">
                  </app-auto-complete-form-standalone>
                }
                <mat-form-field appearance="outline" class="field">
                  <mat-label>{{'IotDevices.externaleDatatype' | translate}}</mat-label>
                  <mat-select formControlName="dataType">
                    @for (type of dataTypes; track type) {
                      <mat-option [value]="type.value">
                        {{ type.label }}
                      </mat-option>
                    }
                  </mat-select>
                  @if (getCommandFormGroup(i).get('dataType')?.hasError('required')) {
                    <mat-error>
                      {{'IotDevices.errorsForm.required' | translate}}
                    </mat-error>
                  }
                </mat-form-field>
                <div class="range-fields">
                  <mat-form-field appearance="outline" class="field range-field">
                    <mat-label>{{'min'|translate}}</mat-label>
                    <input matInput type="number" formControlName="min" placeholder="0">
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="field range-field">
                    <mat-label>{{'max'|translate}}</mat-label>
                    <input matInput type="number" formControlName="max" placeholder="100">
                  </mat-form-field>
                </div>
              </div>
            </mat-expansion-panel>
          }
        </mat-accordion>
        @if (commandsFormArray.length === 0) {
          <div class="empty-state">
            <mat-icon>info</mat-icon>
            <p>{{'IotDevices.externalInfoNotSet' | translate}}</p>
          </div>
        }
        <mat-divider style="margin: 5px 0;"></mat-divider>
        <div>
          <button mat-flat-button color="accent" (click)="menuTrigger.closeMenu()">
            <mat-icon>check</mat-icon>
          </button>
        </div>
      </form>
    </div>
  </mat-menu>
</div>